<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)">
    <template #content>
      <!-- Dislike form -->
      <div
        :class="{
          'dislike-form': true,
          'dislike-form--disabled': props.isDisabled,
        }"
      >
        <div class="dislike-form__header">
          <h2 class="global-h2 dislike-form__title">What missed the mark? <span class="dislike-form__optional-mark">(optional)</span></h2>
          <!--<div class="dislike-form__subtitle">Any guidance helps us improve future suggestions</div>-->
        </div>

        <div class="dislike-form__checkboxes-row">
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Wrong Theme" v-model="formData.reasons" /></template>
            <template #text>Wrong Theme</template>
          </SrpCheckbox>
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Images Unrelated" v-model="formData.reasons" /></template>
            <template #text>Images Unrelated</template>
          </SrpCheckbox>
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Low Quality Photos" v-model="formData.reasons" /></template>
            <template #text>Low Quality Images</template>
          </SrpCheckbox>
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Poor Caption" v-model="formData.reasons" /></template>
            <template #text>Poor Caption</template>
          </SrpCheckbox>
          <!--<SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Other" v-model="formData.reasons" /></template>
            <template #text>Other</template>
          </SrpCheckbox>-->
        </div>

        <!--<div class="dislike-form__textarea-title">or just tell us:</div>-->

        <textarea class="global-textarea dislike-form__textarea" v-model="formData.feedback" placeholder="Any specifics you can share?"></textarea>
      </div>
      <!-- / Dislike form -->
    </template>

    <template #footer="{ closeModal }">
      <slot name="footer" :closeModal="closeModal" :combinedFeedbackString="combinedFeedbackString" />
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpCheckbox from "@components/ui/SrpCheckbox.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    isDisabled?: boolean;
  }>(),
  {
    isDisabled: false,
  }
);

const emit = defineEmits<{
  (e: "update:isVisible", isVisible: boolean): void;
}>();

// Form Data ==================================================================
class FormData {
  reasons: Array<string> = [];
  feedback = "";
}

const formData = ref<FormData>(new FormData());

// Reasons and feedback string ================================================
const combinedFeedbackString = computed<string>(() => {
  let combinedFeedbackString = "";

  if (formData.value.reasons.length) {
    combinedFeedbackString = formData.value.reasons.join(", ");
  }

  if (formData.value.reasons.length && formData.value.feedback.length) {
    combinedFeedbackString += ", \n";
  }
  combinedFeedbackString += formData.value.feedback;

  return combinedFeedbackString;
});
</script>

<style scoped lang="scss">
// Dislike form ===============================================================
.dislike-form {
  color: rgba(91, 91, 91, 1);
  font: 14px/19px sans-serif;

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__header {
    margin-bottom: 25px;
  }

  &__title {
    margin-bottom: 2px;
  }

  &__optional-mark {
    color: rgba(0, 0, 0, 0.5);
    font-weight: 500;
  }

  &__subtitle {
  }

  &__checkboxes-row {
    gap: 10px;
    margin-bottom: 25px;
    display: flex;
    flex-wrap: wrap;
  }

  &__checkbox {
  }

  &__textarea-title {
    margin-bottom: 10px;
  }

  &__textarea {
    height: 70px;
    min-height: 70px;
  }
}
</style>
